import { useToast } from "@/hooks/use-toast"
import { useEffect, useState } from "react"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()
  const [shouldHideToasts, setShouldHideToasts] = useState(false)

  // Monitor SMS input focus to hide toasts and prevent focus stealing
  useEffect(() => {
    const checkSMSInputFocus = () => {
      const isSMSInputFocused = document.querySelector('[data-sms-input="true"]:focus')
      const isAnyTextareaFocused = document.activeElement?.tagName === 'TEXTAREA'
      const isInSMSPage = window.location.pathname.includes('/sms')
      
      setShouldHideToasts(!!(isSMSInputFocused || (isInSMSPage && isAnyTextareaFocused)))
    }

    // Check on focus/blur events
    document.addEventListener('focusin', checkSMSInputFocus)
    document.addEventListener('focusout', checkSMSInputFocus)
    
    // Prevent focus stealing by toasts
    const preventFocusSteal = (e: Event) => {
      const target = e.target as HTMLElement
      const isSMSInput = document.querySelector('[data-sms-input="true"]:focus')
      
      if (isSMSInput && target && target.closest('[data-radix-toast-viewport]')) {
        e.preventDefault()
        e.stopPropagation()
        ;(isSMSInput as HTMLElement).focus()
      }
    }
    
    document.addEventListener('focus', preventFocusSteal, true)
    document.addEventListener('click', preventFocusSteal, true)
    
    // Also check on location changes
    checkSMSInputFocus()

    return () => {
      document.removeEventListener('focusin', checkSMSInputFocus)
      document.removeEventListener('focusout', checkSMSInputFocus)
      document.removeEventListener('focus', preventFocusSteal, true)
      document.removeEventListener('click', preventFocusSteal, true)
    }
  }, [])

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast 
            key={id} 
            {...props}
            style={{
              display: shouldHideToasts ? 'none' : undefined,
              ...props.style
            }}
          >
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport 
        style={{
          pointerEvents: shouldHideToasts ? 'none' : undefined,
          opacity: shouldHideToasts ? 0 : undefined,
          zIndex: shouldHideToasts ? -1 : undefined,
        }}
      />
    </ToastProvider>
  )
}
